import { Tab } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../redux/types'
import TabPanel from '../../../../../shared/components/TabPanel'
import useTabState from '../../../../../shared/hooks/useTabState'
import { isClient, isManager } from '../../../utils/RolesHelper'
import { TabContainer } from '../../styles/detail/TabContainer'
import DisableUser from './DisableUser'
import EnableUser from './EnableUser'
import UserBrands from './UserBrands'
import UserHistory from './UserHistory'
import UserLinked from './UserLinked'
import UserNotifications from './UserNotifications'
import UserRegistrations from './UserRegistrations'
import UserInfo from './info/UserInfo'

export function UserDetailTabs({ userId }: { userId: number | null }) {
  const { t } = useTranslation(['global'])
  const { currentTab, setCurrentTab, a11yProps } = useTabState()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userProfileSelected } = useSelector((state: IRootState) => state.user)

  return (
    <>
      <TabContainer value={currentTab} onChange={(_, value) => setCurrentTab(value)}>
        <Tab label={t('general')} {...a11yProps(0)} />
        <Tab label={t('admin.people.dependents')} {...a11yProps(1)} style={{ display: isClient(authUser.role_id) ? 'none' : '' }} />
        <Tab label={t('admin.people.notifications')} {...a11yProps(2)} style={{ display: 'none' }} />
        <Tab label={t('brands')} {...a11yProps(3)} />
        <Tab label={t('rows')} {...a11yProps(4)} style={{ display: isManager(authUser.role_id) ? '' : 'none' }} />
        <Tab label={t('inscriptions')} {...a11yProps(5)} />
      </TabContainer>
      <TabPanel value={currentTab} index={0}>
        <UserInfo userId={userId} />
        <EnableUser authUser={authUser} userProfileSelected={userProfileSelected} />
        <DisableUser authUser={authUser} userProfileSelected={userProfileSelected} />
      </TabPanel>
      <TabPanel value={currentTab} index={1}>
        <UserLinked userId={userId} />
      </TabPanel>
      <TabPanel value={currentTab} index={2}>
        <UserNotifications />
      </TabPanel>
      <TabPanel value={currentTab} index={3}>
        <UserBrands />
      </TabPanel>
      <TabPanel value={currentTab} index={4}>
        <UserHistory userId={userId} />
      </TabPanel>
      <TabPanel value={currentTab} index={5}>
        <UserRegistrations userId={userId} />
      </TabPanel>
    </>
  )
}
